import { useQuery } from "@tanstack/react-query";
import { useOutletContext } from "react-router";
import type { ShellOutletContext } from "@/components/app-shell";
import { myProjectsQuery } from "./api";

import type { MembershipProject } from "@zworks/console-contracts";

/**
 * The project the page reads, and whether the memberships answer has arrived. Inside the shell
 * this is the switcher's project; outside the shell (and in tests that mount the page directly)
 * it is the first membership, matching the shell's default. Null while loading or when the
 * caller belongs nowhere.
 */
export function useCurrentProject(): { project: MembershipProject | null; loaded: boolean } {
  const outlet = useOutletContext<ShellOutletContext | null>();
  const memberships = useQuery(myProjectsQuery);
  if (outlet !== null && outlet !== undefined)
    return { project: outlet.currentProject, loaded: true };
  return { project: memberships.data?.[0] ?? null, loaded: !memberships.isPending };
}
